import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class RBC_RESIDENTIAL_SCT_VARIABLE_Mapper extends BaseFormMapper<RBC_RESIDENTIAL_SCT_VARIABLE> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: RBC_RESIDENTIAL_SCT_VARIABLE,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as RBC_RESIDENTIAL_SCT_VARIABLE);

		return _formData;
	}

	MapValues(): Partial<RBC_RESIDENTIAL_SCT_VARIABLE> {
		return {};
	}
}

const Mappings: RBC_RESIDENTIAL_SCT_VARIABLE = {
	title1: 'title',
	name1: 'name',
	title2: 'title2',
	name2: 'name2',
	signature2: 'signature2',
	signature1: 'signature',
	guarantors: 'guarantor names',
	chargors: 'chargors names',
	date2Year: 'year2',
	date1Year: 'year',
	date2Month: 'day of_2',
	date2Day: 'DATED the_2',
	date1Month: 'day of',
	date1Day: 'DATED the',
};

export interface RBC_RESIDENTIAL_SCT_VARIABLE {
	date1Day: string;
	date1Month: string;
	date1Year: string;

	chargors: string;

	date2Day: string;
	date2Month: string;
	date2Year: string;

	guarantors: string;

	signature1: string;
	name1: string;
	title1: string;

	signature2: string;
	name2: string;
	title2: string;
}
